import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({
	providedIn: 'root',
})
export class UtilsService {
	private subject = new Subject<any>();

	constructor(private http: HttpClient, private authService: AuthService) {}

	/**
	 * Recebe todas as linhas, caso line seja especificado, procura com aquela substring
	 * @param line caso queira especificar uma substring para a busca
	 */
	getLines(line?: string): Observable<any> {
		const body = {
			line: line ? line : '',
			paginate: false,
			location: 'e92a593e-308d-4c8a-bd14-aa7da19292aa',
		};

		return this.http.post<any>(
			'https://j41up8rou5.execute-api.us-west-2.amazonaws.com/stage/list-bus-lines',
			body
		);
	}

	/**
	 * Faz a conversão da lista de registros para CSV
	 */
	public getCsv(denounces, from?, to?): void {
		let csv =
			'identificador;tipo_agressao;situacao;local;no_momento;linha_do_onibus;numero_do_onibus;data_criacao;data_acontecimento;latitude;longitude;midia;nome_terminal;id_usuario\n';

		denounces.forEach((row) => {
			let description;

			if (row.description !== undefined) {
				description = row.description.replace(';', ':');
			}

			csv += row._id !== undefined ? row._id : '';
			csv +=
				';' + (row.type !== undefined ? this.transformType([row.type[0]]) : '');
			csv +=
				';' +
				(row.situation !== undefined
					? this.transformSituation(row.situation)
					: '');
			csv +=
				';' + (row.place !== undefined ? this.translatePlace(row.place) : '');
			csv += ';' + (row.at_moment === true ? 'no momento' : 'após');
			csv += ';' + (row.line_number !== undefined ? row.line_number : '');
			csv += ';' + (row.bus_number !== undefined ? row.bus_number : '');
			csv += ';' + (row.created_at !== undefined ? this.transformStrtoDateBr(row.created_at) : '');
			csv += ';' + (row.datetime !== undefined ? this.transformStrtoDateBr(row.datetime) : '');
			csv += ';' + (row.latitude !== undefined ? row.latitude : '');
			csv += ';' + (row.longitude !== undefined ? row.longitude : '');
			csv += ';' + (row.media !== undefined ? row.media : '');
			csv += ';' + (row.terminal_name !== undefined ? row.terminal_name : '');
			csv += ';' + (row.user_id !== undefined ? row.user_id : '');
			csv += '\n';
		});

		const hiddenElement = document.createElement('a');

		const timeNow = new Date();
		const time = timeNow.toISOString().split('T')[0];

		hiddenElement.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csv);
		hiddenElement.target = '_blank';
		hiddenElement.download = from
			? `casos_from_${String(from.toISOString().split('T')[0])}_to_${String(
					to.toISOString().split('T')[0]
			  )}.csv`
			: `casos_${time}.csv`;
		hiddenElement.click();
		hiddenElement.remove();
	}

	/**
	 * Retorna o Número da Linha que o ônibus rodava no horário
	 * @params busNumber, date
	 * Número do ônibus e a data que o ônibus rodava
	 */
	getLineByNumber(busNumber: string, date: Date): Observable<any> {
		const d = new Date(date);

		let month = '' + (d.getMonth() + 1);
		let day = '' + d.getDate();
		const year = d.getFullYear();

		if (month.length < 2) {
			month = '0' + month;
		}
		if (day.length < 2) {
			day = '0' + day;
		}

		const horario =
			[year, month, day].join('-') + ' ' + d.toLocaleString().split(' ')[1];

		const URL =
			environment.ETUFOR_URL + `?veiculo=${busNumber}&horario=${horario}`;

		return this.http.get<any>(URL, {
			headers: {
				apiKey: environment.ETUFOR_KEY,
			},
		});
	}

	/**
	 * Retorna um Observable cuja resposta é o endereço da localização do usuário
	 * @params latitude, longitude
	 */
	getLocationAddress(lat: number, lon: number): Observable<any> {
		return this.http.get<any>(
			'https://maps.googleapis.com/maps/api/geocode/json?latlng=' +
				lat +
				',' +
				lon +
				'&key=' +
				environment.GOOGLE_API_KEY
		);
	}

	/**
	 * Retorna um Observable cuja resposta é a latitude e longitude do usuário
	 * @params endereço
	 */
	getLocationLatLong(address: string): Observable<any> {
		return this.http.get<any>(
			'https://us1.locationiq.com/v1/search.php?format=json&key=' +
				environment.LOCATION_IQ_KEY +
				'&q=' +
				address
		);
	}

	sendMenuClickEvent(): void {
		this.subject.next();
	}

	getClickEvent(): Observable<any> {
		return this.subject.asObservable();
	}

	translatePlace(location: string): string {
		if (location === 'BUS_STOP') {
			return 'Parada de ônibus';
		} else if (location === 'BUS_TERMINUS') {
			return 'Terminal de ônibus';
		} else if (location === 'BUS') {
			return 'Ônibus';
		} else if (location === 'TERMINAL') {
			return 'Terminal';
		} else if (location == 'OTHERS' || location == 'OTHER'){
			return 'Outros';
		} else if (location == "AT_FESTIVAL") {
			return "No festival";
		} else if (location == "FESTIVAL_SURROUNDINGS") {
			return "Nos arredores do festival";
		} else if (location == "FESTIVAL_BUS") {
			return "Linha de ônibus do festival";
		} else {
			return location;
		}
	}

	/**
	 * Retorna a o valor da data em ptbr e em string
	 * @params date
	 */
	transformStrtoDateBr(date: string):String{
		return new Date(date).toLocaleString('pt-BR').toString();
	}

	/**
	 * Retorna a tradução da situação para PT de forma apresentável
	 * @params gender
	 */
	transformSituation(situ: any): string {
		if (situ[0] === 'WITNESS') {
			return 'Testemunha';
		} else if (situ[0] === 'VICTIM') {
			return 'Vítima';
		}
	}

	translateGender(gender: string): string {
		if (gender === 'WOMAN_CIS') {
			return 'Mulher Cis';
		} else if (gender === 'WOMAN_TRANS') {
			return 'Mulher Trans';
		} else if (gender === 'MAN_CIS') {
			return 'Homem Cis';
		} else if (gender === 'MAN_TRANS') {
			return 'Homem Trans';
		} else if (gender === 'NON_BINARY') {
			return 'Não Binário';
		} else {
			return '';
		}
	}

	translateType(type: string): string {
		if (type === 'OTHERS') {
			return 'Outros';
		} else if (type === 'SELF_TOUCH_OR_FLASHING') {
			return 'Se tocou ou mostrou';
		} else if (type === 'GROPING') {
			return 'Encoxar/Apalpar';
		} else if (type === 'STALKING') {
			return 'Perseguição';
		} else if (type === 'COERCION') {
			return 'Intimidação';
		} else if (type === 'UNWANTED_PHOTOS') {
			return 'Foto não autorizada';
		} else if (type === "VERBAL_HARASSMENT") {
			return "Agressão Verbal";
		} else if (type === "PHYSICAL_AGGRESSION") {
			return "Agressão Física";
		} else if (type === "FORCED_KISS") {
			return "Beijo Forçado / Violentaram / Tentaram violentar";
		} else {
			return type;
		}
	}

	/**
	 * Retorna a tradução da agressão para PT de forma apresentável
	 * @params [type]
	 */
	transformType(types: string[]): string {
		let translatedTypes = types.map(this.translateType);

		return translatedTypes.join(', ');
	}
}
